const filterDuplicatedOrders = (previosOrders, newOrders) => {
  const newOrderIdsMap = {}

  previosOrders.forEach(previosOrder => {
    newOrderIdsMap[previosOrder._id] = true
  })

  const result =
    newOrders.filter(newOrder =>
      !newOrderIdsMap[newOrder._id]
    )

  return result
}

export default filterDuplicatedOrders